import ApiService from '@/services/core/api.service'

const BorrowingService = {
  async get (query) {
    return ApiService.get(`user/borrowings?${query}`)
  },

  async post (payload) {
    return ApiService.post('user/borrowings', payload)
  },

  async put (payload) {
    return ApiService.put(`user/borrowings/${payload.id}`, payload)
  }
}

export default BorrowingService
